// import { HttpAdapter } from "../../../config/http/http.adapter";
import { HttpAdapter } from '../../../config/http/http.adapter';
import { YieldFeesTraceResponse } from '../../../infraestructure/interfaces/yield-fees-trace.interface';
import { YieldFeesTraceMapper } from '../../../infraestructure/mappers/yield-fees-trace.mapper';
import { YieldFeesChart } from '../../entities/general/YieldFeesChart.entity';
import { handleError } from '../../handle-error/handleError';
import moment from 'moment';

// Fecha actual en el formato deseado
const currentDate = moment().format('YYYY-MM-DD');

// Fecha restando 12 meses
const originDate = moment().subtract(12, 'months').format('YYYY-MM-DD');

interface Props {
  clientId: string;
  dateFrom: string | Date;
  dateTo: string | Date;
  bankId?: string;
  accountNumber?: string;
}

export const YieldFeesTraceUseCases = async (
  fetcher: HttpAdapter,
  props: Props
): //   fetcher: HttpAdapter
Promise<YieldFeesChart> => {
  try {
    const {
      clientId,
      dateFrom = originDate,
      dateTo = currentDate,
      bankId,
      accountNumber,
    } = props;

    const requestData: Record<string, string> = {
      clientId: `${clientId}`,
      dateFrom: `${dateFrom}`,
      dateTo: `${dateTo}`,
    };

    if (bankId) {
      requestData.bankId = `${bankId}`;
    }

    if (accountNumber) {
      requestData.accountNumber = `${accountNumber}`;
    }

    const response = await fetcher.post<YieldFeesTraceResponse>(
      '/data-ms/yield-fees-trace',
      requestData
    );

    return YieldFeesTraceMapper.fromResponseToEntity(response);
  } catch (error: any) {
    const processedError = handleError(error);
    console.error('Error procesado:', processedError);
    throw new Error(`${processedError.message} ${processedError.status}`);
  }
};
